import { createContext, type JSX } from "react";

export const WidgetHeaderWrapperContext = createContext<JSX.Element | false>(false);
